import { render } from "./Hound.vue?vue&type=template&id=4b7fcfec&scoped=true&ts=true"
import script from "./Hound.vue?vue&type=script&lang=ts"
export * from "./Hound.vue?vue&type=script&lang=ts"

import "./Hound.vue?vue&type=style&index=0&id=4b7fcfec&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7fcfec"]])

export default __exports__